import program1 from "~/assets/icons/body.svg";
import program2 from "~/assets/icons/situp.svg";
import program3 from "~/assets/icons/food.svg";

export const programData = [
  {
    id: 1,
    icon: program1,
    title: "Personalized weight loss treatment",
    text: "Our doctors prescribe monthly GLP-1 medications, ensuring safe and supervised weight loss.",
  },
  {
    id: 2,
    icon: program2,
    title: "Online fitness training",
    text: "Follow our expert-led virtual workout sessions and simple home workout videos, designed for all fitness levels.",
  },
  {
    id: 3,
    icon: program3,
    title: "Customized nutrition plan",
    text: "Enjoy a customized nutrition plan designed for your body, lifestyle, and goals, without sacrificing your favorite foods.",
  },
];
